export default {
    LOGIN_URL: 'sessions/authorize',
    CONNECT_URL: 'sessions/socket',
    LOGOUT_URL: 'sessions/self',
};
//# sourceMappingURL=ApiConstants.js.map